import React, { Component } from "react";
import $, { get } from "jquery";
import { ToastContainer, toast } from "react-toastify";
import JournalContent from "./JournalContent";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import DataTable from "react-data-table-component";
import { Multiselect } from "multiselect-react-dropdown";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import cssu
import { tokenVerification } from "./Utils";
class ManageJournal extends Component {
  constructor(props) {
    super(props);
    this.multiselectRef = React.createRef();
    this.dialogClose = () => {
      this.setState({
        hideDeletePopup: false,
      });
    };
    this.DeletedialogClose = () => {
      this.setState({ hideTextAreaPopup: false });
    };

    this.settings = { effect: "Zoom", duration: 400, delay: 0 };

    //for delete dialog component ok click
    this.buttons = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          this.deleteManageJournal(this.state.propsId);
          this.setState({ disableAddButton: false });
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideDeletePopup: false,
            disableAddButton: false,
          });
        },
      },
    ];

    //for delete success
    this.deleteSuccessbuttons = [
      {
        buttonModel: {
          content: "Ok",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          this.deletionConfirmationDialog.hide();
          this.fetchJournal();
          this.setState({ disableAddButton: false });
        },
      },
    ];

    this.state = {
      healthSystemGroupValue: [],
      startLoader: false,
      healthSystemId: "",
      hospitalId: "",
      serviceLineId: "",
      value: [],
      procedureData: "",
      loadedData: [],
      disableAddButton: false,
      editedId: "-1",
      editImageSrc: "./assets/images/edit.svg",
      contentEditable: "false",
      hidden: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      pageNum: null,
      selectedDate: new Date(),
      paginationValue: 10,
      hospitalGroupValue: [],
      providerRole: false,
      scopeGroup: [],
      noJournalData: false,
      selectedJournalId: "",
      showSummConfig: false,
      dateFields: [],
      timeFields: [],
      integerFields: [],
      summConfigObject: {
        sumOn: [],
      },
      isLoading: true,
      highlightReminder: {},
      highlightSummation: {},
      sumOnPresent: false,
      searchTerm: "",
      noMatchingData: false,
      addingNewRow: false,
      highlightMilestoneButton: {},
      tableReady: false,
    };

    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
    this.scopeType = [];
    this.scopeGroup = [];
    this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    this.healthSystemDropDownInJournalRef = React.createRef();
    this.hospitalDropDownInJournalRef = React.createRef();
  }

  componentDidMount() {
    var thisController = this;
    const savedPage = localStorage.getItem("lastJournalActivePage");
    if (savedPage !== null) {
      thisController.restoredPage = parseInt(savedPage);
      localStorage.removeItem("lastJournalActivePage");
    } else {
      thisController.restoredPage = 1;
    }

    thisController.state.healthSystemId =
      localStorage.getItem("healthSystemId");
    thisController.state.hospitalId = localStorage.getItem("hospitalId");
    thisController.state.serviceLineId = localStorage.getItem("serviceLineId");
    setTimeout(() => {
      thisController.fetchHealthSystemDetails();
      // thisController.fetchHospitalDetails();
      thisController.fetchScopeType();
      thisController.fetchJournal();
    }, 300);
  }

  setDefaultsForSummConfig = () => {
    this.setState({
      selectedJournalId: "",
      dateFields: [],
      timeFields: [],
      integerFields: [],
      summConfigObject: {
        sumOn: [],
      },
    });
  };

  fetchScopeType = () => {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/journal-type",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          var scopeTypeInfo = res.result;
          var numberOfScopeType = scopeTypeInfo.length;
          thisController.scopeType = [];
          for (var i = 0; i < numberOfScopeType; i++) {
            if (scopeTypeInfo[i]["name"] != "SERVICE_LINE") {
              thisController.scopeType[i] = scopeTypeInfo[i];
            }
          }
        }
      },
    });
  };
  onChangeScopeType = (props, e) => {
    //   var scopeType = props.type;
    // props.type = e.target.value;
    // props.title = document.getElementById("titleId" + props.id).innerText;
    // if (props.type == 'SERVICE_LINE') {
    //     this.fetchScopeGrpSL(props.type);
    // } else if (props.type == 'TREATMENT') {
    //     this.fetchScopeGrpTreatment(props.type);
    // }
    var scopeType;
    if (props == null || props == undefined) {
      scopeType = this.scopeTypes[0].name;
    } else {
      props.type = e.target.value;
      scopeType = props.type;
    }

    if (scopeType == "HEALTH_SYSTEM") {
      this.fetchScopeGrpHS(scopeType);
      this.setState(this.state);
    } else if (scopeType == "HOSPITAL") {
      this.fetchScopeGrpHospital(scopeType);
      this.setState(this.state);
    } else if (scopeType == "SERVICE_LINE") {
      this.fetchScopeGrpSL(scopeType);
      this.setState(this.state);
    } else if (scopeType == "TREATMENT") {
      this.fetchScopeGrpTreatment(scopeType);
      this.setState(this.state);
    }
  };
  fetchScopeGrpHS = (scopeType) => {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/fetch-journal-group",

      method: "GET",
      data: {
        journalScope: scopeType,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          var scopeGroupInfo = res.result;
          var numberOfScopeGrp = scopeGroupInfo.length;
          thisController.scopeGroup = [];
          for (var i = 0; i < numberOfScopeGrp; i++) {
            thisController.scopeGroup[i] = scopeGroupInfo[i];
          }
        }
      },
    });
  };
  fetchScopeGrpHospital = (scopeType) => {
    var thisController = this;
    var healthSystem = thisController.userDetails["healthSystemId"];
    $.ajax({
      url: "/my-jeeva-api/fetch-journal-group",

      method: "GET",
      data: {
        journalScope: scopeType,
        healthSystemId: healthSystem,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          var scopeGroupInfo = res.result;
          var numberOfScopeGrp = scopeGroupInfo.length;
          thisController.scopeGroup = [];
          for (var i = 0; i < numberOfScopeGrp; i++) {
            thisController.scopeGroup[i] = scopeGroupInfo[i];
          }
        }
      },
    });
  };
  fetchScopeGrpSL = (scopeType) => {
    var thisController = this;
    var hospitalId = thisController.userDetails["hospitalId"];
    var healthSystem = thisController.userDetails["healthSystemId"];
    var userRole = thisController.userDetails["userRole"];
    var serviceLineId = thisController.userDetails["serviceLineId"];
    if (serviceLineId == "null" || serviceLineId == null) {
      serviceLineId = "00000000-0000-0000-0000-000000000000";
    }
    if (healthSystem == null) {
      healthSystem = thisController.state.healthSystemId;
    }
    if (hospitalId == null) {
      hospitalId = thisController.state.hospitalId;
    }

    $.ajax({
      url: "/my-jeeva-api/fetch-journal-group",

      method: "GET",
      data: {
        journalScope: scopeType,
        healthSystemId: healthSystem,
        hospitalId: hospitalId,
        serviceLineId: serviceLineId,
        userRole: userRole,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          var scopeGroupInfo = res.result;
          var numberOfScopeGrp = scopeGroupInfo.length;
          thisController.state.scopeGroup = [];
          thisController.setState(thisController.state);
          for (var i = 0; i < numberOfScopeGrp; i++) {
            var serviceLineId = thisController.userDetails["serviceLineId"];
            var userRole = thisController.userDetails["userRole"];
            if (userRole == "SERVICELINE_ADMIN" || userRole == "PHYSICIAN") {
              if (scopeGroupInfo[i].id == serviceLineId) {
                thisController.state.scopeGroup[i] = scopeGroupInfo[i];
                thisController.setState(thisController.state);
              }
            } else {
              thisController.state.scopeGroup.push(scopeGroupInfo[i]);
              thisController.setState(thisController.state);
            }
          }
        }
      },
    });
  };
  fetchScopeGrpTreatment = (scopeType) => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var healthSystem = thisController.userDetails["healthSystemId"];
    var hospitalId = thisController.userDetails["hospitalId"];
    var serviceLine = thisController.userDetails["serviceLineId"];
    if (serviceLine == "null" || serviceLine == null) {
      serviceLine = "00000000-0000-0000-0000-000000000000";
    }
    if (healthSystem == null) {
      healthSystem = thisController.state.healthSystemId;
    }
    if (hospitalId == null) {
      hospitalId = thisController.state.hospitalId;
    }
    if (userRole == "PHYSICIAN") {
      var providerId = JSON.parse(localStorage.getItem("user_details"))[
        "userId"
      ];
      var hospitalId = JSON.parse(localStorage.getItem("user_details"))[
        "hospitalId"
      ];
      $.ajax({
        url: "/my-jeeva-api/procedure-treatment",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          providerId: providerId,
          hospitalId: hospitalId,
        },
        success: function (res) {
          if (res.success === true) {
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
            var scopeGroupInfo = res.result;
            scopeGroupInfo = scopeGroupInfo.filter(
              (procedure) => !procedure.isDeactivated
            ).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
            var numberOfScopeGrp = scopeGroupInfo.length;
            thisController.state.scopeGroup = [];
            thisController.setState(thisController.state);
            for (var i = 0; i < numberOfScopeGrp; i++) {

              if (scopeGroupInfo[i].createdBy != null && scopeGroupInfo[i].createdBy === thisController.userDetails["emailId"]) {
                thisController.state.scopeGroup.push(scopeGroupInfo[i]);
                thisController.setState(thisController.state);
              }
            }
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    } else {
      $.ajax({
        url: "/my-jeeva-api/fetch-journal-group",

        method: "GET",
        data: {
          journalScope: scopeType,
          healthSystemId: healthSystem,
          hospitalId: hospitalId,
          serviceLineId: serviceLine,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            // thisController.state.showLoader = true;
            // thisController.setState(thisController.state);
            // var scopeGroupInfo = res.result;
            // var numberOfScopeGrp = scopeGroupInfo.length;
            // thisController.scopeGroup = [];
            // for (var i = 0; i < numberOfScopeGrp; i++) {

            //     thisController.scopeGroup[i] = (scopeGroupInfo[i]);

            // }
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
            var scopeGroupInfo = res.result;
            scopeGroupInfo = scopeGroupInfo.filter(
              (procedure) => !procedure.isDeactivated
            );
            var numberOfScopeGrp = scopeGroupInfo.length;
            thisController.state.scopeGroup = [];
            thisController.setState(thisController.state);
            for (var i = 0; i < numberOfScopeGrp; i++) {
              thisController.state.scopeGroup.push(scopeGroupInfo[i]);
              thisController.setState(thisController.state);
            }
          }
        },
      });
    }
  };
  addEmptyRow = () => {
    console.log("Adding Empty Row");
    var thisController = this;
    thisController.state.paginationValue =
      thisController.state.paginationValue + 5;
    if (thisController.state.pageNum != 0) {
      thisController.setState({ pageNum: 0 });
    }
    // thisController.state.loadedData.unshift({
    //   id: "",
    //   name: "",
    //   type: "",
    //   journalGroupId: "",
    //   typeName: "",
    //   journalGroupName: "",
    // });
    var row = {
      id: "",
      name: "",
      type: "",
      journalGroupId: "",
      typeName: "",
      journalGroupName: "",
      createdByEmail: "",
    };
    var allData = [row, ...thisController.state.loadedData];
    thisController.state.loadedData = allData;
    thisController.state.noMatchingData = false;
    thisController.state.disableAddButton = true;
    thisController.state.addingNewRow = true;
    thisController.setState(thisController.state);
    thisController.fetchScopeGrpTreatment("TREATMENT");
  };
  fetchNumberOfDays() {
    var thisController = this;
    var responseData = [];
    $.ajax({
      url: "/my-jeeva-api/number-of-days",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          var response = res.result;
          var length = response.length;
          thisController.loadedNumberOfDaysInfo = [];

          for (var i = 0; i < length; i++) {
            thisController.loadedNumberOfDaysInfo[i] = response[i];
          }
        } else {
          thisController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva/";
        }
      },
    });
  }
  fetchWhenData() {
    var thisController = this;
    var responseData = [];
    $.ajax({
      url: "/my-jeeva-api/when-data",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          var response = res.result;
          var length = response.length;
          thisController.loadedWhenInfo = [];

          for (var i = 0; i < length; i++) {
            thisController.loadedWhenInfo[i] = response[i];
          }
        } else {
          thisController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva/";
        }
      },
    });
  }
  fetchIntentNamesApi() {
    var thisController = this;
    var responseData = [];
    $.ajax({
      url: "/my-jeeva-api/intent-names",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          var response = res.result;
          var length = response.length;
          thisController.loadedIntentNameInfo = [];

          for (var i = 0; i < length; i++) {
            thisController.loadedIntentNameInfo[i] = response[i];
          }
        } else {
          thisController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva/";
        }
      },
    });
  }

  notifyMsgFieldEmpty() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields
      </b>,
      {
        position: "top-center",
      }
    );
  }
  showAddJournalPopUp = (props) => { };
  closePatientDataPopUp = () => {
    this.state.editedId = "-1";
    this.setState(this.state);
    this.setState({ showAddSureveyModal: false });
  };
  updateEpisodeApi = (props, e) => {
    props.name = document.getElementById("name" + props.id).innerText.trim();
    props.when = document.getElementById("when" + props.id).value;
    props.numberOfDays = document.getElementById(
      "numberOfDays" + props.id
    ).value;
    props.intentName = document.getElementById("intentName" + props.id).value;
    var saveData = {
      id: props.id,
      name: props.name,
      numberOfDays: props.numberOfDays,
      when: props.when,
      intentName: props.intentName,
      patientId: localStorage.getItem("patientId"),
    };
    var updateController = this;
    $.ajax({
      url: "/my-jeeva-api/update-episode",

      method: "PATCH",
      data: JSON.stringify(saveData),
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      success: function (res) {
        if (res.success === true) {
          if (res.success === true) {
            updateController.state.editedId = "-1";
            updateController.notifuEpisodeUpdated();
            updateController.fetchEpisodeDataApi();
          } else {
            updateController.notifyFailedResponse(res.result);
          }
        } else {
          updateController.notifyFailedToUpdate(res.result);
          updateController.state.disableAddButton = false;
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva/login";
        }
      },
    });
  };

  notifuEpisodeUpdated() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Episode details updated successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyFailedToUpdate(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  makeCelledit(props, e) {
    this.markAsBeingEdited(props.id);
  }

  markAsBeingEdited(id) {
    var thisController = this;
    thisController.state.editedId = id;
    var stateObj = thisController.state;
    thisController.setState(stateObj);
    thisController.fetchScopeGrpTreatment("TREATMENT");
  }

  notifyError() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Oops! Error occurred.Please try again
      </b>,
      {
        position: "top-center",
      }
    );
  }


  fetchHealthSystemDetails() {
    var thisController = this;
    var responseData = [];
    $.ajax({
      url: "/my-jeeva-api/health-system",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          responseData = res.result;
          var totalCount = responseData.length;
          thisController.state.healthSystemGroupValue = [];
          for (var i = 0; i < totalCount; i++) {
            thisController.state.healthSystemGroupValue.push({
              name: res.result[i].name,
              value: res.result[i].id,
            });
          }
          if (!thisController.state.healthSystemId) {
            var healthSystemsDropDownList =
              thisController.healthSystemDropDownInJournalRef.current;
            if (healthSystemsDropDownList) {
              thisController.state.healthSystemId =
                healthSystemsDropDownList.value;
              setTimeout(() => {
                thisController.onHealthSystemChange({
                  target:
                    thisController.healthSystemDropDownInJournalRef.current,
                });
              }, 100);
            } else {
              thisController.state.healthSystemId = res.result[0].id;
              setTimeout(() => {
                thisController.onHealthSystemChange({
                  target:
                    thisController.healthSystemDropDownInJournalRef.current,
                });
              }, 100);
            }
          }
          thisController.setState(thisController.state);
          thisController.fetchHospitalDetails();
        } else {
          thisController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  }
  fetchHospitalDetails() {
    var thisController = this;
    var responseData = [];
    var healthSystemId;
    var userRole = thisController.userDetails["userRole"];
    if (userRole == "HOSPITAL_ADMIN" || userRole == "SERVICELINE_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
    } else if (userRole == "ADMIN") {
      healthSystemId = thisController.state.healthSystemId;
    } else {
      healthSystemId = thisController.userDetails["healthSystemId"];
    }
    $.ajax({
      url: "/my-jeeva-api/hospital",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        healthSystemId: healthSystemId,
      },
      success: function (res) {
        if (res.success === true) {
          thisController.setState({ hospitalGroupValue: [] });

          if (res.result.length == 0) {
            thisController.state.noJournalData = true;
            thisController.setState(thisController.state);
          } else {
            thisController.state.noJournalData = false;
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
            responseData = res.result;
            var totalCount = responseData.length;
            thisController.state.hospitalGroupValue = [];
            for (var i = 0; i < totalCount; i++) {
              thisController.state.hospitalGroupValue.push({
                name: res.result[i].name,
                value: res.result[i].id,
              });
            }
            thisController.setState(thisController.state);

            if (
              localStorage.getItem("hospitalId") == "" ||
              thisController.state.hospitalId == null
            ) {
              if (totalCount > 0) {
                thisController.state.hospitalId = res.result[0].id;
                setTimeout(() => {
                  thisController.onHospitalChange({
                    target: thisController.hospitalDropDownInJournalRef.current,
                  });
                }, 100);
                localStorage.setItem(
                  "hospitalId",
                  thisController.state.hospitalId
                );
              }
            }
          }
        } else {
          thisController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  }
  fetchJournal() {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    thisController.state.isLoading = true;
    thisController.state.loadedData = [];
    thisController.setState(thisController.state);
    var healthSystemId;
    var hospitalId;
    if (userRole == "ADMIN") {
      healthSystemId = localStorage.getItem("healthSystemId");
      hospitalId = localStorage.getItem("hospitalId");
    } else if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = JSON.parse(localStorage.getItem("user_details"))[
        "healthSystemId"
      ];
      hospitalId = localStorage.getItem("hospitalId");
    } else {
      healthSystemId = JSON.parse(localStorage.getItem("user_details"))[
        "healthSystemId"
      ];
      hospitalId = JSON.parse(localStorage.getItem("user_details"))[
        "hospitalId"
      ];
    }

    if (userRole != "PHYSICIAN") {
      $.ajax({
        url: "/my-jeeva-api/fetch-journal-other-role",

        method: "GET",
        data: {
          healthSystemId: healthSystemId,
          hospitalId: hospitalId,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success == true) {
            if (res.result.length == 0) {
              thisController.state.noJournalData = true;
              thisController.state.noMatchingData = false;
              thisController.state.isLoading = false;
              thisController.setState(thisController.state);
            } else {
              thisController.state.noJournalData = false;
              thisController.state.noMatchingData = false;
              thisController.state.editable = false;
              thisController.state.disableAddButton = false;
              thisController.state.isLoading = false;
              thisController.state.loadedData = res.result;
              if (thisController.state.loadedData.length > 0) {
                thisController.checkJournalStatusBatch(thisController.state.loadedData);
              }
              thisController.state.pageNum = thisController.restoredPage || 1;
              thisController.state.tableReady = true;
              thisController.setState(thisController.state);
            }
          }
        },
      });
    } else {
      $.ajax({
        url: "/my-jeeva-api/fetch-journal-for-doctors",

        method: "GET",
        data: {
          healthSystemId: thisController.userDetails["healthSystemId"],
          hospitalId: thisController.userDetails["hospitalId"],
          serviceLineId: thisController.userDetails["serviceLineId"],
          providerId: thisController.userDetails["userId"]
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success == true) {
            if (res.result.length == 0) {
              thisController.state.noJournalData = true;
              thisController.state.isLoading = false;
              thisController.state.noMatchingData = false;
              thisController.setState(thisController.state);
            } else {
              thisController.state.noJournalData = false;
              thisController.state.editable = false;
              thisController.state.disableAddButton = false;
              thisController.state.noMatchingData = false;
              thisController.state.isLoading = false;
              thisController.state.loadedData = res.result;
              if (thisController.state.loadedData.length > 0) {
                thisController.checkJournalStatusBatch(thisController.state.loadedData);
              }
              thisController.state.pageNum = thisController.restoredPage || 1;
              thisController.state.tableReady = true;
              thisController.setState(thisController.state);
            }
          }
        },
      });
    }
  }

  checkJournalStatusBatch = (rows) => {
    if (!rows || rows.length === 0) return;

    var statusController = this;
    var journalIds = rows.map(row => row.id);

    // Call milestone batch API
    $.ajax({
      url: "/my-jeeva-api/journal-status-batch",
      method: "POST",
      data: JSON.stringify(journalIds),
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json"
      },
      dataType: "json",
      success: function (res) {
        if (res.success === true) {
          const milestoneMap = res.result;
          let newHighlightMilestone = {};

          for (const [journalId, status] of Object.entries(milestoneMap)) {
            newHighlightMilestone[journalId] = status.hasMilestone || false;
          }

          statusController.setState(prevState => ({
            highlightMilestoneButton: {
              ...prevState.highlightMilestoneButton,
              ...newHighlightMilestone
            }
          }));
        }
      },
    });

    // Call reminder batch API
    $.ajax({
      url: "/my-jeeva-api/journal-reminder-batch",
      method: "POST",
      data: JSON.stringify(journalIds),
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json"
      },
      dataType: "json",
      success: function (res) {
        if (res.success === true) {
          const reminderMap = res.result;
          let newHighlightReminder = {};

          for (const [journalId, status] of Object.entries(reminderMap)) {
            newHighlightReminder[journalId] = status.hasReminder || false;
          }

          statusController.setState(prevState => ({
            highlightReminder: {
              ...prevState.highlightReminder,
              ...newHighlightReminder
            }
          }));
        }
      },
    });

    // Call summation batch API
    $.ajax({
      url: "/my-jeeva-api/journal-summation-batch",
      method: "POST",
      data: JSON.stringify(journalIds),
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json"
      },
      dataType: "json",
      success: function (res) {
        if (res.success === true) {
          const summationMap = res.result;
          let newHighlightSummation = {};

          for (const [journalId, status] of Object.entries(summationMap)) {
            newHighlightSummation[journalId] = status.hasSummation || false;
          }

          statusController.setState(prevState => ({
            highlightSummation: {
              ...prevState.highlightSummation,
              ...newHighlightSummation
            }
          }));
        }
      },
    });
  }

  highlightJournalHasReminder = (row) => {
    // Fallback for single row check
    this.checkJournalStatusBatch([row]);
  }

  highlightJournalHasSummation = (row) => {
    // Fallback for single row check
    this.checkJournalStatusBatch([row]);
  }

  highlightJournalHasMilestone = (row) => {
    // Fallback for single row check
    this.checkJournalStatusBatch([row]);
  }

  deleteManageJournal = async (id) => {
    if (id == "") {
      this.setState(prevState => {
        const updatedData = [...prevState.loadedData];
        const index = updatedData.findIndex(item => item.id === id);
        if (index !== -1) updatedData.splice(index, 1);
        return { loadedData: updatedData, hideDeletePopup: false, hideDeleteSuccessPopup: true };
      });
      return;
    }

    try {
      const response = await fetch(`/my-jeeva-api/delete-journal/${id}`, {
        method: "DELETE",
        headers: {
          "Authorization": "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json"
        },
        priority: "high"
      });

      const res = await response.json();

      if (res.success === true) {
        this.setState(prevState => {
          const updatedData = [...prevState.loadedData];
          const index = updatedData.findIndex(item => item.id === id);
          if (index !== -1) updatedData.splice(index, 1);
          return {
            loadedData: updatedData,
            deleteRow: true,
            hideDeletePopup: false
          };
        });
        this.notifyDelete();
      }
    } catch (xhr) {
      if (xhr.status == 401) {
        window.location.href = "";
      }
    }
  };

  // deleteManageJournal = (id) => {
  //   let deleteRowViewController = this.state.loadedData;
  //   let deleteApiViewController = this;
  //   var deleteConstructorVariables = this;

  //   if (id == "") {
  //     deleteApiViewController.setState({ deleteRow: true });
  //     deleteConstructorVariables.setState({ hideDeletePopup: false });
  //     deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
  //     deleteRowViewController.splice(id, 1);
  //   } else {
  //     $.ajax({
  //       url: "/my-jeeva-api/delete-journal/" + id,

  //       method: "DELETE",
  //       headers: {
  //         Authorization: "Bearer " + localStorage.getItem("access_token"),
  //       },
  //       success: function (res) {
  //         if (res.success === true) {
  //           deleteApiViewController.setState({ deleteRow: true });
  //           deleteConstructorVariables.setState({ hideDeletePopup: false });
  //           deleteConstructorVariables.notifyDelete();
  //           deleteRowViewController.splice(id, 1);
  //           deleteConstructorVariables.refreshData();
  //         } else {
  //           // deleteRowViewController.notifyError();
  //         }
  //       },
  //       error: function (xhr) {
  //         if (xhr.status == 401) {
  //           window.location.href = "";
  //         }
  //       },
  //     });
  //   }

  //   if (this.state.deleteRow) {
  //     this.state.loadedData.splice(id, 1);
  //   }
  //   deleteConstructorVariables.fetchJournal();
  // };

  onHealthSystemChange = (e) => {
    var selectBox = e.target;
    localStorage.setItem("hospitalId", "");
    localStorage.setItem("hospitalName", "");
    this.state.dontOverLap = true;
    if (this.state.healthSystemId != selectBox.value) {
      this.state.hospitalId = null;
      localStorage.setItem(`hospitalName`, null);
    }
    this.state.healthSystemId = selectBox.value;
    localStorage.setItem("healthSystemId", this.state.healthSystemId);
    var healthSystemName = selectBox.options[selectBox.selectedIndex].innerText;
    localStorage.setItem("healthSystemName", healthSystemName);
    this.state.hospitalId = document.getElementById("hospitalDropDown").value;

    this.setState(this.state);
    window.journalNavBarController.paintPatientAdmissionHeading();
    this.fetchHospitalDetails();
  };

  onHospitalChange = (e) => {
    this.state.isLoading = true;
    var selectBox = e.target;
    this.state.dontOverLap = true;
    if (this.state.hospitalId != selectBox.value) {
      this.state.serviceLineId = null;
    }
    this.state.hospitalId = selectBox.value;
    if (selectBox.value != "") {
      var hospitalName = selectBox.options[selectBox.selectedIndex].innerText;
      localStorage.setItem("hospitalName", hospitalName);
    }
    localStorage.setItem("hospitalId", this.state.hospitalId);

    this.setState(this.state);
    window.journalNavBarController.paintPatientAdmissionHeading();
    this.fetchJournal();
  };

  refreshData = (id) => {
    this.state.isLoading = true;
    this.state.noMatchingData = false;
    this.state.searchTerm = "";
    this.setState(this.state);
    var refreshContent = this;
    refreshContent = this.state.editedId = id;
    this.fetchJournal();
    this.setState({ disableAddButton: false });
  };

  notifuEpisodeAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Episode added successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyDelete() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Journal detail deleted successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  CustomNoDataComponent = (props) => (
    <div style={{ textAlign: 'center' }}>
      {props.length === 0 ? <p> There are no records for survey</p> :
        <p></p>}
    </div>
  );

  notifyJournalCloned() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Journal cloned successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifySummConfig() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp; Configuration saved.
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyFailedResponse(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  onPageChange = (e) => {
    this.restoredPage = e;
    this.setState({ pageNum: e });
    localStorage.setItem("lastJournalActivePage", e);
  };

  scopeGroupHandleChange = (props, e) => {
    props.title = document.getElementById("titleId" + props.id).innerText;

    props.type = document.getElementById("scopeTypeId" + props.id).value;
    props.typeName = document.getElementById("scopeTypeId" + props.id).options[
      document.getElementById("scopeTypeId" + props.id).selectedIndex
    ].text;
    props.journalGroupName = document.getElementById(
      "journalGroupId" + props.id
    ).options[
      document.getElementById("journalGroupId" + props.id).selectedIndex
    ].text;
    props.journalGroupId = e.target.value;
    this.setState(this.state);
  };

  saveJournalInfoApi = (props, e) => {
    this.state.editedId = "-1";
    this.setState(this.state);
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var providerId;
    var providerName;
    var healthSystemId;
    var hospitalId;
    if (userRole == "ADMIN") {
      (healthSystemId = localStorage.getItem("healthSystemId")),
        (hospitalId = localStorage.getItem("hospitalId"));
    } else if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = JSON.parse(localStorage.getItem("user_details"))[
        "healthSystemId"
      ];
      hospitalId = localStorage.getItem("hospitalId");
    } else {
      healthSystemId = JSON.parse(localStorage.getItem("user_details"))[
        "healthSystemId"
      ];
      hospitalId = JSON.parse(localStorage.getItem("user_details"))[
        "hospitalId"
      ];
    }

    providerId = JSON.parse(localStorage.getItem("user_details"))["userId"];
    providerName = JSON.parse(localStorage.getItem("user_details"))["name"];


    var title = document.getElementById("titleId" + props.id).innerText.trim();
    var titlePattern = new RegExp(
      /^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/
    );
    if (title == "") {
      thisController.notifyEmptyFields();
    } else if (!titlePattern.test(title)) {
      thisController.notifyImproperTitle();
    } else {
      var addJournalData = {
        title: title,
        createdByEmail: thisController.userDetails["emailId"],
        createdByName: thisController.userDetails["name"],
        type: document.getElementById("scopeTypeId" + props.id).value,
        journalGroupId: document.getElementById("journalGroupId" + props.id)
          .value,
        typeName: document.getElementById("scopeTypeId" + props.id).options[
          document.getElementById("scopeTypeId" + props.id).selectedIndex
        ].text,
        journalGroupName: document.getElementById("journalGroupId" + props.id)
          .options[
          document.getElementById("journalGroupId" + props.id).selectedIndex
        ].text,
        providerId: providerId,
        providerName: providerName,
        hospitalId: hospitalId,
        healthSystemId: healthSystemId,
      };
      $.ajax({
        url: "/my-jeeva-api/add-journal",

        method: "POST",
        data: JSON.stringify(addJournalData),
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },

        success: function (res) {
          if (res.success === true) {
            thisController.state.editable = true;
            thisController.notifyJournalAdded();
            thisController.fetchJournal();
            thisController.setState({ disabled: false });
          } else {
            thisController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }
  };

  updateJournalInfoApi = (row, e) => {
    var updateController = this;
    var title = document.getElementById("titleId" + row.id).innerText.trim();
    var titlePattern = new RegExp(
      /^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/
    );
    updateController.state.typeName = document.getElementById(
      "scopeTypeId" + row.id
    ).options[
      document.getElementById("scopeTypeId" + row.id).selectedIndex
    ].text;

    updateController.state.journalGroupName = document.getElementById(
      "journalGroupId" + row.id
    ).options[
      document.getElementById("journalGroupId" + row.id).selectedIndex
    ].text;
    updateController.setState(updateController.state);
    var updatedData = {
      id: row.id,
      title: title,
      createdByEmail: updateController.userDetails["emailId"],
      createdByName: updateController.userDetails["name"],
      type: document.getElementById("scopeTypeId" + row.id).value,
      journalGroupId: document.getElementById("journalGroupId" + row.id).value,
      typeName: updateController.state.typeName,
      journalGroupName: updateController.state.journalGroupName,
    };
    if (title == "") {
      updateController.notifyEmptyFields();
    } else if (!titlePattern.test(title)) {
      updateController.notifyImproperTitle();
    } else {
      $.ajax({
        url: "/my-jeeva-api/update-journal",

        method: "PATCH",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        data: JSON.stringify(updatedData),
        success: function (res) {
          if (res.success === true) {
            updateController.state.editedId = "-1";
            updateController.state.disabled = false;
            updateController.notifyJournalUpdate();
            updateController.fetchJournal();
            updateController.setState(updateController.state);
          } else {
            updateController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }
  };
  notifyJournalUpdate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Journal updated successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyEmptyFields() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields before saving
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyImproperTitle() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid title
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyImproperDate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Kindly enter a valid date.
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyJournalAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;New journal created successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifySelectHospital() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please select hospital.
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifySelectHealthSystem() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please select health system.
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyNoJournalItems = () => {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;No Journal Items present.
      </b>,
      {
        position: "top-center",
      }
    );
  };

  addQuestion = (props, e) => {
    localStorage.setItem("journalCreatedBy", props.createdByEmail);
    const pageToSave = this.state.pageNum || 1;
    localStorage.setItem("lastJournalActivePage", pageToSave);

    if (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN) {
      if (this.state.hospitalId == "Select Hospital") {
        this.notifySelectHospital();
      } else {
        this.props.history.push({
          pathname: "/projectmgmt/add-journal-question",
          state: {
            healthSystemId: this.state.healthSystemId,
            hospitalId: this.state.hospitalId,
            currentJournalId: props.id,
          },
        });
        this.setState(this.setState);
      }
    } else if (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.ADMIN) {
      if (this.state.healthSystemId == "Select Health System") {
        this.notifySelectHealthSystem();
      } else if (this.state.hospitalId == "Select Hospital") {
        this.notifySelectHospital();
      } else {
        this.props.history.push({
          pathname: "/projectmgmt/add-journal-question",
          state: {
            healthSystemId: this.state.healthSystemId,
            hospitalId: this.state.hospitalId,
            currentJournalId: props.id,
          },
        });
        this.setState(this.setState);
      }
    } else {
      this.props.history.push({
        pathname: "/projectmgmt/add-journal-question",
        state: {
          healthSystemId: this.state.healthSystemId,
          hospitalId: this.state.hospitalId,
          currentJournalId: props.id,
        },
      });
      this.setState(this.setState);
    }
  };

  showPatientDetails = (row, e) => {
    localStorage.setItem("journalId", row.id);
    localStorage.setItem("journalTitle", row.title);
    localStorage.setItem("procedureName", row.journalGroupName);
    localStorage.setItem("journalCreatedName", row.createdByName);
    const pageToSave = this.state.pageNum || 1;
    localStorage.setItem("lastJournalActivePage", pageToSave);

    this.props.history.push("/projectmgmt/journal/view-result");
  };

  addJournalReminder = (row, e) => {
    localStorage.setItem("journalTitle", row.title);
    localStorage.setItem("journalCreatedBy", row.createdByEmail);
    const pageToSave = this.state.pageNum || 1;
    localStorage.setItem("lastJournalActivePage", pageToSave);

    this.props.history.push({
      pathname: "/projectmgmt/journal-reminder",
      state: {
        journalId: row.id,
        pageNum: this.state.pageNum,
        createdByEmail: row.createdByEmail,
      },
    });
    this.setState(this.setState);
  };

  addJournalMilestone = (row, e) => {
    localStorage.setItem("journalTitle", row.title);
    localStorage.setItem("journalCreatedBy", row.createdByEmail);
    const pageToSave = this.state.pageNum || 1;
    localStorage.setItem("lastJournalActivePage", pageToSave);

    this.props.history.push({
      pathname: "/projectmgmt/journal-milestone",
      state: {
        treatmentId: row.journalGroupId,
        journalId: row.id,
        journalName: row.title,
        treatmentName: row.journalGroupName,
        createdByEmail: row.createdByEmail,
        pageNum: this.state.pageNum,
      },
    });
    this.setState(this.setState);
  };

  openDeletePopUp = (props) => {
    confirmAlert({
      title: "Confirm to Delete",
      message: `Are you sure you want to delete ${props.title} ?`,
      buttons: [
        {
          label: "Yes",
          onClick: () => this.deleteManageJournal(props.id),
        },
        {
          label: "No",
        },
      ],
    });
  };

  handleCloneJournal = (journalRow) => {
    const userDetails = this.userDetails;
    var healthSystemId = localStorage.getItem("healthSystemId");
    var hospitalId = localStorage.getItem("hospitalId");
    console.log("cloning journal for : ", userDetails.emailId);
    var journalData = {};
    journalData.id = journalRow.id;
    journalData.title = journalRow.title;
    journalData.journalGroupName = journalRow.journalGroupName;
    journalData.journalGroupId = journalRow.journalGroupId;
    journalData.type = journalRow.type;
    journalData.typeName = journalRow.typeName;
    journalData.scheduledDate = journalRow.scheduledDate;
    journalData.createdByName = userDetails.name;
    journalData.createdByEmail = userDetails.emailId;
    journalData.healthSystemId = healthSystemId || userDetails.healthSystemId;
    if (userDetails.userRole === "HEALTHSYSTEM_ADMIN") {
      journalData.healthSystemId = userDetails.healthSystemId;
    }
    journalData.hospitalId = hospitalId || userDetails.hospitalId;
    if (
      userDetails.userRole === "HOSPITAL_ADMIN" ||
      userDetails.userRole === "SERVICELINE_ADMIN"
    ) {
      journalData.healthSystemId = userDetails.healthSystemId;
      journalData.hospitalId = userDetails.hospitalId;
    }

    console.log({
      healthSystemId: journalData.healthSystemId,
      hospitalId: journalData.hospitalId,
    });
    journalData.providerId = userDetails.userId;
    journalData.providerName = userDetails.name;

    this.cloneJournal(journalData);
  };

  cloneJournal = (journal) => {
    console.log("journal : ", journal);
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/clone-journal",
      method: "POST",
      data: JSON.stringify(journal),
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },

      success: function (res) {
        if (res.success === true) {
          thisController.state.editable = true;
          thisController.notifyJournalCloned();
          thisController.refreshData();
          thisController.setState({ disabled: false });
        } else {
          thisController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  };

  getSysDate = () => {
    var now = new Date();
    return now.getMonth() + 1 + "/" + now.getDate() + "/" + now.getFullYear();
  };

  fetchJournalItemsAndOpenSummOverlay(journalId, title, journalCreatedBy) {
    var fetchController = this;
    fetchController.state.selectedJournalId = journalId;
    localStorage.setItem("journalTitle", title);
    localStorage.setItem("journalCreatedBy", journalCreatedBy);
    fetchController.setState(fetchController.state);
    $.ajax({
      url: "/my-jeeva-api/fetch-journal-item",

      method: "GET",
      data: {
        userEmail: JSON.parse(localStorage.getItem("user_details"))["emailId"],
        journalId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success == true) {
          if (res.result.length == 0) {
            fetchController.notifyNoJournalItems();
          } else {
            var dateFields = [];
            var integerFields = [];
            var timeFields = [];
            var items = res.result;
            for (var i = 0; i < items.length; i++) {
              if (items[i].type === "DATE") {
                dateFields.push(items[i].label);
              } else if (items[i].type === "INTEGER") {
                integerFields.push({ label: items[i].label });
              } else if (items[i].type === "TIME") {
                timeFields.push(items[i].label);
              }
            }
            dateFields.push("systemDate");
            timeFields.push("systemTime");
            fetchController.setState({
              dateFields,
              integerFields,
              timeFields,
            });
            fetchController.fetchJournalSummationConfig(journalId);
          }
        } else {
          fetchController.setState({ showSummConfig: true });
        }
      },
    });
  }

  fetchJournalSummationConfig(journalId) {
    var fetchController = this;
    $.ajax({
      url: "/my-jeeva-api/get-journal-Summation",

      method: "GET",
      data: {
        journalId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success == true) {
          console.log("response object: ", res.result);
          var summConfigObject = res.result;
          var selectedData = summConfigObject.sumOn.split(",");
          var sumOnArray = [];
          for (let label of selectedData) {
            if (label !== "") {
              sumOnArray.push({ label });
            }
          }
          if (sumOnArray.length > 0) {
            fetchController.state.sumOnPresent = true;
            fetchController.setState(fetchController.state);
          }
          summConfigObject = { ...summConfigObject, sumOn: sumOnArray };
          fetchController.setState({
            summConfigObject,
            showSummConfig: true,
          });
        } else {
          fetchController.setState({ showSummConfig: true });
        }
      },
    });
  }

  closeSummConfigOverlay = () => {
    this.setDefaultsForSummConfig();
    this.setState({
      showSummConfig: false,
      sumOnPresent: false
    });
  };

  saveSummationConfig = (summConfig) => {
    var thisController = this;
    $.ajax({
      url: "/my-jeeva-api/save-journal-summation",
      method: "POST",
      data: JSON.stringify(summConfig),
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },

      success: function (res) {
        if (res.success === true) {
          thisController.state.editable = true;
          thisController.notifySummConfig();
          thisController.closeSummConfigOverlay();
          thisController.refreshData();
          thisController.setState({ disabled: false });
        } else {
          thisController.notifyFailedResponse(res.result);
        }
        thisController.setDefaultsForSummConfig();
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  };

  caseInsensitiveSort = (field) => (rowA, rowB) => {

    const a = rowA[field] ? rowA[field].toLowerCase() : '';
    const b = rowB[field] ? rowB[field].toLowerCase() : '';

    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  };

  handleSearch = (event) => {
    var thisController = this;
    thisController.state.searchTerm = event.target.value;
    thisController.state.isLoading = true;
    thisController.state.loadedData = [];
    thisController.setState(thisController.state);
    if (event.target.value == "") {
      thisController.state.noMatchingData = false;
      thisController.setState(thisController.state);
      thisController.fetchJournal();

    } else {
      var healthSystemId;
      var hospitalId;
      var userRole = thisController.userDetails["userRole"];

      if (userRole == "ADMIN") {
        healthSystemId = localStorage.getItem("healthSystemId");
        hospitalId = localStorage.getItem("hospitalId");
      } else if (userRole == "HEALTHSYSTEM_ADMIN") {
        healthSystemId = JSON.parse(localStorage.getItem("user_details"))[
          "healthSystemId"
        ];
        hospitalId = localStorage.getItem("hospitalId");
      } else {
        healthSystemId = JSON.parse(localStorage.getItem("user_details"))[
          "healthSystemId"
        ];
        hospitalId = JSON.parse(localStorage.getItem("user_details"))[
          "hospitalId"
        ];
      }
      var userEmail = thisController.userDetails["emailId"];

      $.ajax({
        url: "/my-jeeva-api/search-journal-data",
        method: "GET",
        data: {
          healthSystemId: healthSystemId,
          hospitalId: hospitalId,
          searchTerm: thisController.state.searchTerm,
          userRole: userRole,
          userEmail: userEmail
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },

        success: function (res) {
          if (res.success === true) {
            if (res.result.length > 0) {
              thisController.state.loadedData = [];
              thisController.state.noMatchingData = false;
              thisController.setState(thisController.state);
              thisController.state.loadedData = res.result;
              thisController.state.isLoading = false;
              thisController.setState(thisController.state);
            } else {
              thisController.state.noMatchingData = true;
              thisController.state.isLoading = false;
              thisController.setState(thisController.state);
            }
          }
        },
        error: function (xhr) {

        },
      });
    }
  };

  clearSearchData = () => {
    var thisController = this;
    thisController.setState({ searchTerm: "" }, () => {
      thisController.state.healthSystemId =
      localStorage.getItem("healthSystemId");
    thisController.state.hospitalId = localStorage.getItem("hospitalId");
    thisController.state.serviceLineId = localStorage.getItem("serviceLineId");
    setTimeout(() => {
      thisController.fetchHealthSystemDetails();
      // thisController.fetchHospitalDetails();
      thisController.fetchScopeType();
      thisController.fetchJournal();
    }, 300);
    });
}
  

  render() {
    const { loadedData } = this.state;
    const journal_column = [
      // {
      //   name: <b style={{ fontSize: "16px" }}>Title</b>,
      //   sortable: true,
      //   sortFunction: this.caseInsensitiveSort('title'),
      //   selector: (props) => (
      //     <div name="name">
      //       <div
      //         className="textarea"
      //         style={{
      //           background: "white",
      //           height: "2.7em",
      //           resize: "none",
      //           paddingLeft: "2px",
      //           paddingTop: "6px",
      //           width: "98%",
      //           border:
      //             props.id == "" || props.id == this.state.editedId
      //               ? "1px solid #D2D4DC"
      //               : "none",
      //           borderRadius: props.id == "" ? "2px" : "none",
      //           color:
      //             window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PHYSICIAN
      //               ? "#007bff"
      //               : "",
      //           cursor: this.state.disableAddButton
      //             ? ""
      //             : !(
      //               window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PHYSICIAN
      //             )
      //               ? ""
      //               : props.id == this.state.editedId
      //                 ? ""
      //                 : "pointer",
      //         }}
      //         id={"titleId" + props.id}
      //         contentEditable={
      //           !(props.id == "" ? false : props.id != this.state.editedId)
      //             ? "plaintext-only"
      //             : false
      //         }
      //         onClick={(e) =>
      //           this.state.disableAddButton
      //             ? ""
      //             : !(
      //               window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PHYSICIAN
      //             )
      //               ? ""
      //               : props.id == this.state.editedId
      //                 ? ""
      //                 : this.addQuestion(props, e)
      //         }
      //       >
      //         {props.title}
      //       </div>
      //     </div>
      //   ),
      // },

      {
        name: <b style={{ fontSize: "16px" }}>Title</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('title'),
        selector: (props) => {
          const userDetails = JSON.parse(localStorage.getItem('user_details'));
          let backgroundColor = "white";
          let tooltipText = "";

          if (userDetails && userDetails.userRole === "PHYSICIAN") {
            const emailId = userDetails.emailId;
            backgroundColor = props.createdByEmail !== emailId && props.id !== "" ? 'lightblue' : 'white';
            tooltipText = props.createdByEmail !== emailId && props.id !== "" ? "Read-only journal defined by admin" : "";
          }

          return (
            <div name="name">
              <div
                className="textarea"
                style={{
                  background: backgroundColor,
                  height: "2.7em",
                  resize: "none",
                  paddingLeft: "2px",
                  paddingTop: "6px",
                  width: "98%",
                  border:
                    props.id === "" || props.id === this.state.editedId
                      ? "1px solid #D2D4DC"
                      : "none",
                  borderRadius: props.id === "" ? "2px" : "none",
                  color:
                    window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PHYSICIAN
                      ? "#007bff"
                      : "",
                  cursor: this.state.disableAddButton
                    ? ""
                    : !(
                      window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PHYSICIAN
                    )
                      ? ""
                      : props.id === this.state.editedId
                        ? ""
                        : "pointer",
                }}
                id={"titleId" + props.id}
                contentEditable={
                  !(props.id === "" ? false : props.id !== this.state.editedId)
                    ? "plaintext-only"
                    : false
                }
                onClick={(e) =>
                  this.state.disableAddButton
                    ? ""
                    : !(
                      window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PHYSICIAN
                    )
                      ? ""
                      : props.id === this.state.editedId
                        ? ""
                        : this.addQuestion(props, e)
                }
                title={tooltipText}
              >
                {props.title}
              </div>
            </div>
          );
        },
      },

      {
        name: <b style={{ fontSize: "16px" }}> Scope Type</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('typeName'),
        selector: (props) => (
          <div name="name">
            <div
              className="textarea"
              style={{
                display: !(props.id == ""
                  ? false
                  : props.id != this.state.editedId)
                  ? "none"
                  : "block",
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "98%",
                border:
                  props.id == "" || props.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: props.id == "" ? "2px" : "none",
              }}
              //   id={"scopeTypeId" + props.id}
              contentEditable={
                !(props.id == "" ? false : props.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {props.typeName}
            </div>
            { }
            <select
              className="input-group form-control select2 "
              onChange={(e) => this.onChangeScopeType(props, e)}
              value={props.type}
              id={"scopeTypeId" + props.id}
              style={{
                display: !(props.id == ""
                  ? false
                  : props.id != this.state.editedId)
                  ? "block"
                  : "none",
                background: "white",
                border: "none",
                border:
                  props.id == undefined || props.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: props.id == undefined ? "2px" : "none",
              }}
              disabled={
                props.id == "" ? false : props.id != this.state.editedId
              }
            >
              {this.scopeType.map((scopeTypeInfo) => (
                <option key={scopeTypeInfo} value={scopeTypeInfo["name"]}>
                  {scopeTypeInfo["code"]}
                </option>
              ))}
              <option hidden value="Select Scope Type">
                Select Scope Type
              </option>
            </select>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Scope Group</b>,
        sortable: true,
        sortFunction: this.caseInsensitiveSort('journalGroupName'),
        selector: (props) => (
          <div name="name">
            <div
              className="textarea"
              style={{
                display: !(props.id == ""
                  ? false
                  : props.id != this.state.editedId)
                  ? "none"
                  : "block",
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "98%",
                border:
                  props.id == "" || props.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: props.id == "" ? "2px" : "none",
              }}
              // id={"journalGroupId" + props.id}
              contentEditable={
                !(props.id == "" ? false : props.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {props.journalGroupName}
            </div>
            <select
              className="input-group form-control select2 "
              onChange={(e) => this.scopeGroupHandleChange(props, e)}
              value={props.journalGroupId}
              id={"journalGroupId" + props.id}
              style={{
                display: !(props.id == ""
                  ? false
                  : props.id != this.state.editedId)
                  ? "block"
                  : "none",
                background: "white",
                border: "none",
                border:
                  props.id == undefined || props.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: props.id == undefined ? "2px" : "none",
              }}
              disabled={
                props.id == "" ? false : props.id != this.state.editedId
              }
            >
              {/* The fetched list leaves out deactivated treatments and, for a provider, ones
                  they did not create - keep the journal's current group so editing shows it
                  instead of silently selecting the first treatment. */}
              {props.id !== "" && props.journalGroupId &&
                !this.state.scopeGroup.some((scopeGroupnames) => scopeGroupnames.id === props.journalGroupId) && (
                  <option key={props.journalGroupId} value={props.journalGroupId}>
                    {props.journalGroupName}
                  </option>
                )}
              {this.state.scopeGroup.map((scopeGroupnames) => (
                <option value={scopeGroupnames.id}>
                  {scopeGroupnames.name}
                </option>
              ))}
              <option hidden value="Select Scope Group">
                Select Scope Group
              </option>
            </select>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Actions</b>,
        width: 200,
        selector: (props) => (
          <div id="action" style={{ marginTop: "0px" }}>
            <button
              style={{
                display:
                  window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PHYSICIAN
                    ? "inline"
                    : "none",
                backgroundColor: "#ffffff",
                border: "none",
              }}
              onClick={props.id !== "" && this.userDetails["userRole"] === "PHYSICIAN" &&
                JSON.parse(localStorage.getItem('user_details')).emailId !== props.createdByEmail ? null :
                (e) => {
                  props.id == ""
                    ? this.saveJournalInfoApi(props, e)
                    : props.id == this.state.editedId
                      ? this.updateJournalInfoApi(props, e)
                      : this.makeCelledit(props, e);
                }}
            >
              <img
                className="img-responsive"
                title={props.id !== "" && this.userDetails["userRole"] === "PHYSICIAN" &&
                  JSON.parse(localStorage.getItem('user_details')).emailId !== props.createdByEmail ? "Clone journal to edit" :
                  props.id == "" || props.id == this.state.editedId
                    ? "Save"
                    : "Edit"
                }

                disabled={
                  props.id !== "" &&
                  (this.userDetails["userRole"] === "PHYSICIAN" &&
                    JSON.parse(localStorage.getItem('user_details')).emailId !== props.createdByEmail)
                }

                // disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                //   JSON.parse(localStorage.getItem('user_details')).emailId !== props.createdByEmail }
                style={{
                  marginTop: "10px",
                  backgroundColor:
                    props.id === ""
                      ? "#282a65"
                      : (this.userDetails["userRole"] === "PHYSICIAN" &&
                        JSON.parse(localStorage.getItem('user_details')).emailId !== props.createdByEmail)
                        ? "#282a6596"
                        : "#282a65",

                  borderRadius: "5px",
                  padding: "1px",
                }}
                src={
                  props.id == ""
                    ? this.saveImageSrc
                    : props.id != this.state.editedId
                      ? this.editImageSrc
                      : this.saveImageSrc
                }
              />
            </button>

            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                display:
                  window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PHYSICIAN
                    ? props.id == "" || props.id == this.state.editedId
                      ? "none"
                      : "inline"
                    : "none",
              }}
              onClick={(e) => {
                !props.id == ""
                  ? this.handleCloneJournal(props)
                  : () => console.log("empty row");
              }}
            >
              <img
                className="img-responsive"
                title="Clone"
                style={{
                  backgroundColor: "#282a65",
                  borderRadius: "5px",
                  padding: "2px",
                  height: "2rem",
                }}
                src="assets/images/copy-64.png"
              />
            </button>

            {/* Mile stone Button starts */}
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                padding: "0px",
                marginLeft: "4px",
                display: props.id == "" || props.id == this.state.editedId ? "none" : "inline"
              }}
              title="Treatment Milestone"
              onClick={(e) => {
                this.addJournalMilestone(props, e);
              }}
            >
              <img
                className="img-responsive"
                src={"./assets/images/milestone.png"}
                style={{
                  marginTop: "6px",
                  backgroundColor: this.state.highlightMilestoneButton[props.id] ? "rgb(5 162 47)" : "#282a65",
                  // backgroundColor: this.state.discontinued ? "#282a6596" : "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                  height: "2rem"
                }}
              />
            </button>
            {/* Mile stone Button ends */}
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                display:
                  window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PHYSICIAN
                    ? props.id == "" || props.id == this.state.editedId
                      ? "none"
                      : "inline"
                    : "none",
              }}
              // disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
              //   JSON.parse(localStorage.getItem('user_details')).emailId !== props.createdByEmail}
              onClick={(e) => {
                !props.id == ""
                  ? this.fetchJournalItemsAndOpenSummOverlay(
                    props.id,
                    props.title,
                    props.createdByEmail
                  )
                  : () => console.log("empty row");
              }}
            >
              <img
                className="img-responsive"
                title="Cumulative"
                style={{
                  // backgroundColor: "#282a65",
                  backgroundColor:
                    // props.id === ""
                    //   ? "#282a65"
                    //   : (this.userDetails["userRole"] === "PHYSICIAN" &&
                    //     JSON.parse(localStorage.getItem('user_details')).emailId !== props.createdByEmail)
                    //     ? "#282a6596"
                    //     : 
                    this.state.highlightSummation[props.id] ? "rgb(5 162 47)" : "#282a65",

                  borderRadius: "5px",
                  padding: "2px",
                  height: "2rem",
                }}
                src="assets/images/sum.png"
              />
            </button>

            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginLeft: "-6px",
                display:
                  window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PHYSICIAN
                    ? props.id == "" || props.id == this.state.editedId
                      ? "none"
                      : "inline"
                    : "none",

              }}
              title="Notification"
            >
              <img
                className="img-responsive"
                src={"./assets/images/alarm-clock-24.png"}
                style={{
                  marginTop: "-19px",
                  backgroundColor:
                    this.state.highlightReminder[props.id] ? "rgb(5 162 47)" : "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                }}
                onClick={
                  (e) => {
                    this.addJournalReminder(props, e);
                  }}
              />
            </button>

            <button
              className="btn2 table-action-button "
              style={{
                marginBottom:
                  window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PHYSICIAN
                    ? "21px"
                    : "6px",
              }}
              onClick={(e) => {
                this.showPatientDetails(props, e);
              }}
              hidden={props.id == "" ? true : false}
            >
              View Results
            </button>
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginLeft: "-1px",
              }}
              title={this.userDetails["userRole"] === "PHYSICIAN" &&
                JSON.parse(localStorage.getItem('user_details')).emailId !== props.createdByEmail ? "Clone journal to edit" : "Delete"}

              disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                JSON.parse(localStorage.getItem('user_details')).emailId !== props.createdByEmail}
            >
              <img
                className="img-responsive"
                src={"./assets/images/baseline_delete_white_24dp.png"}

                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PHYSICIAN
                      ? "inline"
                      : "none",
                  marginTop: "-19px",
                  backgroundColor: this.userDetails["userRole"] === "PHYSICIAN" &&
                    JSON.parse(localStorage.getItem('user_details')).emailId !== props.createdByEmail
                    ? "#282a6596"
                    : "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                }}
                onClick={() =>
                  props.id === ""
                    ? this.fetchJournal()
                    : this.openDeletePopUp(props)
                }
              />
            </button>
          </div>
        ),
        width: 200,
      },
    ];
    return (
      <div style={{ marginRight: "1%" }} id="manageJournal">
        <div style={{ background: "#F9F9FB" }}>
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          <link
            rel="stylesheet"
            href="assets/css/React_Table_CSS/react-table.css"
          />
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <link
            rel="stylesheet"
            href="plugins/font-awesome/css/font-awesome.min.css"
          />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/toggleButton.css" />

          <div className="row">
            <div className="col-sm-3">
              {/* <h6 className="nav-item" style={{ color: '#282a65', marginTop: '1vh' }}>
                Manage Journals
              </h6> */}
            </div>
            <div className="col-sm-6" Align="right" style={{ marginLeft: "-11vw" }}>
              <label
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.ADMIN
                      ? "inline"
                      : "none",
                }}
              >
                Health System
              </label>

              <select
                value={this.state.healthSystemId}
                id="healthSystem"
                className="healthSystem"
                disabled={this.state.showSummConfig}
                onChange={(e) => this.onHealthSystemChange(e)}
                placeholder="Select Health System"
                ref={this.healthSystemDropDownInJournalRef}
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.ADMIN
                      ? "inline"
                      : "none",
                  height: "30px",
                  borderRadius: "4px",
                  backgroundColor: "#F9F9FB",
                  width: "13vw",
                  marginLeft: "10px",
                }}
              >
                {this.state.healthSystemGroupValue.map((healthSystem) => (
                  <option value={healthSystem.value}>
                    {healthSystem.name}
                  </option>
                ))}
              </select>
              <label
                style={{
                  marginLeft: "15px",
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.HOSPITAL_ADMIN
                      ? "inline"
                      : "none",
                }}
              >
                Hospital
              </label>
              <select
                value={this.state.hospitalId}
                id="hospitalDropDown"
                className="hospital"
                disabled={this.state.showSummConfig}
                onChange={this.onHospitalChange}
                placeholder="Select hospital"
                ref={this.hospitalDropDownInJournalRef}
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.HOSPITAL_ADMIN
                      ? "inline"
                      : "none",
                  height: "30px",
                  borderRadius: "4px",
                  backgroundColor: "#F9F9FB",
                  width: "13vw",
                  marginLeft: "10px",
                }}
              >
                {this.state.hospitalGroupValue.map((hospitalGroup) => (
                  <option value={hospitalGroup.value}>
                    {hospitalGroup.name}
                  </option>
                ))}
              </select>
            </div>
            <div
              style={{ marginLeft: "2vw", 
              // marginTop: "-0.4vh" 
            }}
              >
              <input
                type="text"
                style={{
                  width: "10vw",
                  border: "1px solid #777676",
                  borderRadius: "3px",
                  padding: "10px",
                  height: "0.6vw",
                  paddingRight: "2rem",
                }}
                value={this.state.searchTerm}
                onChange={this.handleSearch}
                placeholder="Search ..."
              />
              {this.state.searchTerm && (
                <span
                  onClick={() => this.clearSearchData()}
                  style={{
                    // position: "absolute",
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#777676",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    lineHeight: 1,
                    userSelect: "none",
                    marginLeft: "-1vw"
                  }}
                >
                  ×
                </span>
              )}
            </div>
            <div 
            // className="col-sm-3" 
            style={{ marginTop: "-24px", marginLeft: "5vw" }}>
              <div className="d-flex flex-row-reverse pt-2">
                <div className="p-2" style={{ marginBottom: "10px" }}>
                  <button
                    className="btn action-button"
                    style={{
                      display:
                        window.SCOPE_VALUE.CURRENT >=
                          window.SCOPE_VALUE.PHYSICIAN
                          ? "inline"
                          : "none",
                    }}
                    id="addMsg"
                    title=" Add "
                    onClick={
                      this.state.disableAddButton
                        ? this.notifyMsgFieldEmpty
                        : this.addEmptyRow
                    }
                  >
                    <img src="assets/images/add_white_24dp.png" />{" "}
                  </button>

                  <button
                    title="Refresh"
                    onClick={this.refreshData}
                    type="button"
                    className="btn action-button"
                  >
                    <img src="./assets/images/refresh_white_24dp.png"></img>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="row" style={{ textAlign: "left" }}>
            <div className="col-lg-12 ">

              <div className="card">
                {this.state.isLoading && (
                  <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>Loading ...</p>
                  </div>
                )}
                {!this.state.isLoading && this.state.loadedData.length === 0 && !this.state.noMatchingData && (
                  <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>There are no records for Journal</p>
                  </div>
                )}
                {(loadedData && !this.state.noMatchingData) && (
                  <DataTable
                    key={"table-" + this.state.pageNum}
                    data={loadedData}
                    columns={journal_column}
                    defaultPageSize={5}
                    pageSizeOptions={[5, 10, 15]}
                    onChangePage={this.onPageChange}
                    paginationDefaultPage={this.state.pageNum || 1}
                    pagination={this.state.paginationValue}
                    noDataComponent={<this.CustomNoDataComponent props={loadedData} />}
                  />
                )}

              </div>
              <ToastContainer className="Toast-at-center" />
              {this.state.showSummConfig && (
                <CumulativeConfigOverlay
                  closeSummConfigOverlay={this.closeSummConfigOverlay}
                  saveSummationConfig={this.saveSummationConfig}
                  dateFields={this.state.dateFields}
                  timeFields={this.state.timeFields}
                  integerFields={this.state.integerFields}
                  selectedIntegerFields={this.state.summConfigObject.sumOn}
                  selectedDateField={this.state.summConfigObject.sumBy}
                  selectedTimeField={this.state.summConfigObject.sumByTime}
                  selectedStartOfDay={this.state.summConfigObject.startOfDay}
                  journalId={this.state.selectedJournalId}
                  isSumOnPresent={this.state.sumOnPresent}
                />
              )}

            </div>
          </div>
          <div className='card'>
            {this.state.noMatchingData &&
              <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                <p>No matching options found ...</p>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

class CumulativeConfigOverlay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startTime: props.selectedStartOfDay || "00:00",
      selectedDateField: props.selectedDateField || props.dateFields[0],
      selectedTimeField: props.selectedTimeField || props.timeFields[0],
      selectedIntegerFields: props.selectedIntegerFields,
      isSumOnPresent: props.isSumOnPresent,
    };
    this.userDetails = JSON.parse(localStorage.getItem("user_details"));
  }

  handleClose = () => {
    this.props.closeSummConfigOverlay();
  };

  notifyMsgFieldEmpty() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields
      </b>,
      {
        position: "top-center",
      }
    );
  }

  handleSave = (msg) => {
    var sumOn = "";
    // take integer fields as comma separated values
    for (let i = 0; i < this.state.selectedIntegerFields.length; i++) {
      if (i === this.state.selectedIntegerFields.length - 1) {
        sumOn += this.state.selectedIntegerFields[i].label;
      } else {
        sumOn += this.state.selectedIntegerFields[i].label + ",";
      }
    }
    var sumBy = this.state.selectedDateField;
    var startOfDay = this.state.startTime;
    var sumByTime = this.state.selectedTimeField;
    if (sumBy === "" || startOfDay === "" || sumByTime === "" || (msg === "save" && sumOn === "")) {
      this.notifyMsgFieldEmpty();
    } else {
      var summConfig = {
        journalId: this.props.journalId,
        sumBy: sumBy,
        startOfDay: startOfDay,
        sumByTime: sumByTime,
        sumOn,
      };
      this.setState({
        selectedIntegerFields: [],
        selectedDateField: "",
        selectedTimeField: "",
      });
      this.props.saveSummationConfig(summConfig);
    }
  };

  handleTimeChange = (e) => {
    console.log("time: ", e.target.value);
    this.setState({ startTime: e.target.value });
  };

  handleSelectIntegerChange = (selectedFields) => {
    this.setState({ selectedIntegerFields: selectedFields });
  };

  handleRemoveIntegerField = (selectedFields) => {
    this.setState({ selectedIntegerFields: selectedFields });
  };



  render() {
    let { dateFields, integerFields, timeFields } = this.props;
    var index = dateFields.indexOf(this.state.selectedDateField);
    var timeIndex = timeFields.indexOf(this.state.selectedTimeField);
    if (index != -1) {
      dateFields.splice(index, 1);
      dateFields.unshift(this.state.selectedDateField);
    }
    if (timeIndex != -1) {
      timeFields.splice(timeIndex, 1);
      timeFields.unshift(this.state.selectedTimeField);
    }
    console.log({
      dateFields,
      integerFields,
      timeFields,
      selectedTimeField: this.state.selectedTimeField,
      selectedDateField: this.state.selectedDateField,
      selectedIntegerFields: this.state.selectedIntegerFields,
    });
    return (
      <div className="overlay" style={{ height: "500px" }}>
        <div className="overlay-header">
          <h4 style={{ marginRight: "100px" }}>
            Journal summation settings for{" "}
            {localStorage.getItem("journalTitle")}{" "}
          </h4>
          <img
            src="./assets/images/clear.svg"
            alt="Close"
            title="Close"
            className="close-icon"
            onClick={this.handleClose}
          />
        </div>
        <div className="overlay-content">
          <div className="form-group-journal">
            <label htmlFor="sumby">Sum On : </label>
            <div style={{ width: "65%", padding: "10px", borderRadius: "6px" }}>
              <Multiselect
                options={integerFields}
                displayValue="label"
                closeIcon="cancel"
                placeholder="Select Fields"
                selectedValues={this.state.selectedIntegerFields}
                // preSelectedValues={this.state.selectedIntegerFields}
                className="multiSelectContainer"
                onSelect={this.handleSelectIntegerChange}
                onRemove={this.handleRemoveIntegerField}
                // onSearch={(e) => this.checkTreatmentName(e)}
                ref={this.multiselectRef}
              />
            </div>
          </div>
          <div className="form-group-journal">
            <label htmlFor="sumby">Sum By Date : </label>
            <select
              style={{
                width: "65%",
                padding: "10px",
                borderRadius: "6px",
                border: "3px solid #282A65",
              }}
              value={this.state.selectedDateField}
              onChange={(e) =>
                this.setState({ selectedDateField: e.target.value })
              }
            >
              {dateFields.map((field, index) => (
                <option key={index} value={field} selected={index === 0}>
                  {field}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group-journal">
            <label htmlFor="sumby">Sum By Time: </label>
            <select
              style={{
                width: "65%",
                padding: "10px",
                borderRadius: "6px",
                border: "3px solid #282A65",
              }}
              value={this.state.selectedTimeField}
              onChange={(e) =>
                this.setState({ selectedTimeField: e.target.value })
              }
            >
              {timeFields.map((field, index) => (
                <option key={index} value={field}>
                  {field}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group-journal">
            <label htmlFor="startOfDay">Start of Day : </label>
            <input
              id="startOfDay"
              style={{
                width: "65%",
                padding: "10px",
              }}
              type="time"
              value={this.state.startTime}
              onChange={(e) => this.handleTimeChange(e)}
            />
          </div>
        </div>
        <div className="overlay-footer">
          {this.state.isSumOnPresent ? (<button className="save-button"
            disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
              JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")}
            style={{
              backgroundColor: this.userDetails["userRole"] === "PHYSICIAN" &&
                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")
                ? "#282a6596"
                : "#282a65",
            }}
            onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
              JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy") ? null :
              () => this.handleSave("update")}>
            Update
          </button>)
            :
            (<button className="save-button"
              disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")}
              style={{
                backgroundColor: this.userDetails["userRole"] === "PHYSICIAN" &&
                  JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")
                  ? "#282a6596"
                  : "#282a65",
              }}
              onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy") ? null : () => this.handleSave("save")}>
              Save
            </button>)}
        </div>
      </div>
    );
  }
}

export default ManageJournal;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ManageJournal.js